module.exports = __webpack_public_path__ + "img/icon_1_10.25fc8054.png";